import axios from 'axios'
import { baseUrl } from '../../../../modules/urls'
import { getAxiosDefaultConfig } from '../../../../modules/utils'
import { parseIntegrationTags } from '../../integrationTags'

export const gmcPatchUrl = (connectionId: string) =>
  `${baseUrl}/auth/google-merchant-center/connections/${encodeURIComponent(connectionId)}`

export const gmcAccountsUrl = (connectionId: string) =>
  `${baseUrl}/auth/google-merchant-center/connections/${encodeURIComponent(connectionId)}/accounts`

export interface GmcAccountOption {
  id: string
  name: string
}

export interface GmcConnectionRow {
  keyId: string
  connectionId: string
  email: string
  merchantCenterAccountId: string
}

function isGmcKeyId(keyId: string | undefined | null): boolean {
  if (keyId == null || keyId === '') return false
  const segment = String(keyId).split('--')[1] || ''
  return segment === 'google_merchant_center' || segment === 'google-merchant-center'
}

export function collectGmcRows(
  channel: { ppKeys?: Array<{ keyId: string; keyValue?: string; tags?: unknown }> } | undefined,
  allPublicKeys: Array<{ keyId: string; keyValue?: string; tags?: unknown }> | undefined
): GmcConnectionRow[] {
  const map = new Map<string, { keyId: string; tags?: unknown; keyValue?: string }>()
  ;(allPublicKeys || []).forEach((row) => {
    if (!row?.keyId || !isGmcKeyId(row.keyId)) return
    map.set(row.keyId, row)
  })
  ;(channel?.ppKeys || []).forEach((row) => {
    if (row?.keyId && isGmcKeyId(row.keyId) && !map.has(row.keyId)) {
      map.set(row.keyId, row)
    }
  })
  return Array.from(map.values()).map((row) => {
    const tm = parseIntegrationTags(row.tags)
    const connectionId =
      String(row.keyValue || '').trim() ||
      String(tm.connectionId || '').trim() ||
      String(row.keyId || '').split('--')[2] ||
      ''
    return {
      keyId: row.keyId,
      connectionId,
      email: String(tm.email || ''),
      merchantCenterAccountId: String(tm.merchantCenterAccountId || tm.merchant_center_account_id || ''),
    }
  })
}

export async function saveMerchantCenterAccountId(connectionId: string, accountId: string): Promise<void> {
  const trimmed = String(accountId || '')
    .trim()
    .replace(/^accounts\//, '')
    .split('/')[0]
  if (!trimmed || !/^\d+$/.test(trimmed)) {
    throw new Error('Enter the numeric account ID from your Merchant Center URL (digits only).')
  }
  await axios.patch(
    gmcPatchUrl(connectionId),
    { merchant_center_account_id: trimmed },
    getAxiosDefaultConfig()
  )
}

export async function fetchGmcAccountsForConnection(
  connectionId: string
): Promise<{ accounts: GmcAccountOption[]; error: string | null }> {
  const res = await axios.get(gmcAccountsUrl(connectionId), getAxiosDefaultConfig())
  const accounts: GmcAccountOption[] = Array.isArray(res.data?.accounts) ? res.data.accounts : []
  const error = res.data?.error ? String(res.data.error) : null
  return { accounts, error }
}
